import React from 'react';
import { Modal,ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { DeleteWSSanitary } from './DeleteWSSanitary';
import { FormWSSanitary } from './FormWSSanitary';
import { Dialog } from 'primereact/dialog';

export const ModalCreateWSSanitaria = (props) => {
    const{
        method, modalTitle, loading, modal, toggle,
        handleInputChange, saveCreate, saveUpdate, saveDelete,
        validaciones, name_ws,id_type_sample,list_determinations,datadeterminations,
        handleUpdateValues,datatypesamples,handleSelectValues,formValues,
        closeDialog
    }=props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        > 
            {
                method === "create"
                ?<FormWSSanitary
                    button = {ModalButtonSave}
                    {...{closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate, name_ws,
                        id_type_sample,list_determinations,datadeterminations,handleUpdateValues,datatypesamples
                        ,handleSelectValues,formValues}}
                />
                :
                (method === "update")
                ?
                <FormWSSanitary
                    button={ModalButtonUpdate}
                    {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, name_ws,
                        id_type_sample,list_determinations,datadeterminations,handleUpdateValues,datatypesamples,handleSelectValues,
                        formValues}}
                />
                :
                    null
            }
        </Dialog>
    )
}